import { useStaticQuery, graphql } from 'gatsby';

import './ModulesRSE.scss';

import ModulesRseBanner from '../Home/ModulesRSE';

export default function ModulesRSE() {
	const data = useStaticQuery(graphql`
		query {
			allMdx(
				filter: {
					fields: {
						collection: { eq: "pages" }
						page: { eq: "home" }
						block: { glob: "modules_rse_*" }
					}
				}
			) {
				edges {
					node {
						id
						body
						fields {
							collection
							page
							block
						}
						frontmatter {
							title
							description
							linkURL
							linkTitle
						}
					}
				}
			}
		}
	`);

	const blocks = data.allMdx.edges.reduce(
		(
			acc,
			{
				node: {
					id,
					body,
					frontmatter,
					fields: { block },
				},
			},
		) => {
			return {
				...acc,
				[block]: {
					id,
					body,
					frontmatter,
				},
			};
		},
		{},
	);

	return (
		<ModulesRseBanner
			blocks={blocks}
			className="modules-rse-banner"
		></ModulesRseBanner>
	);
}
